(function (m, $) {
    m.init = function () {
        const form = $(".ux-target-form");

        form.bind("invalid-form.validate", function () {
            if (!m.testAddressValid())
                m.showAddressError("Address is required.");
        });

        form.data("validator").settings.submitHandler = function (form) {
            if (!m.testAddressValid()) {
                m.showAddressError("Address is required.");
            } else {
                form.submit();
            }
        };

        $(".ux-remote-form input:submit, .ux-remote-form button").click(m.submitForm);
        
        m.initMap();
        m.initScrollBehavior();
    };
    
    var addressInput, autocomplete, addressProcessingLock;
    m.initMap = function () {
        addressInput = document.getElementById("FormattedAddress");
        var autoCompleteOptions = {
            types: ['street_address', 'postal_code', 'route' ],
        };
        autocomplete = new google.maps.places.Autocomplete(addressInput, autoCompleteOptions);
        
        google.maps.event.addListener(autocomplete, "place_changed", function () {
            var place = autocomplete.getPlace();
            if (place.hasOwnProperty("address_components") && !addressProcessingLock) {
                m.setAddressProcessingLock();
                m.hideAddressError();
                m.processAddress(place);
                m.submitForm();
            }
        });
    };
    
    m.initScrollBehavior = function () {
        // Only apply scroll behavior on mobile devices
        if (window.innerWidth <= 768) {
            // Scroll the address input to the top of the viewport when focused
            $("#FormattedAddress").on("focus", function () {
                var inputTop = $(this).offset().top;
                var scrollTop = inputTop - 20; // 20px offset from top
                $("html, body").animate({ scrollTop: scrollTop }, 300);
            });

            // Check if we have results and scroll to them
            if ($(".postcode-lookup-results").length > 0) {
                setTimeout(function () {
                    $("html, body").animate({ 
                        scrollTop: $(".postcode-lookup-results").offset().top
                    }, 500);
                }, 100);
            }
        }
    };
    
    m.processAddress = function (place) {
        if (place.geometry === undefined) {
            m.showAddressError("Coordinates not found, please try a different address.");
            return;
        }

        $(".ux-address-input").val("");

        $("#Latitude").val(place.geometry.location.lat());
        $("#Longitude").val(place.geometry.location.lng());
    };
    

    m.setAddressProcessingLock = function () {
        addressProcessingLock = true;
        setTimeout(m.clearAddressProcessingLock, 500);
    };

    m.clearAddressProcessingLock = function () {
        addressProcessingLock = false;
    };

    m.showAddressError = function (message) {
        var errorContainer = $(".ux-addressinput-error-container");
        var errorMessage = $(".ux-addressinput-error-message");

        errorMessage.html(message);
        errorContainer.show();
    };
    
    m.hideAddressError = function () {
        var errorContainer = $(".ux-addressinput-error-container");
        var errorMessage = $(".ux-addressinput-error-message");

        errorMessage.html("");
        errorContainer.hide();
    };
    
    m.testAddressValid = function () {
        var latitude = $("#Latitude").val();
        var longitude = $("#Longitude").val();

        return latitude !== "" && longitude !== "" && latitude !== "0" && longitude !== "0";
    };

    m.submitForm = function () {
        var targetForm = $(".ux-target-form");
        targetForm.submit();
        return false;
    };
}(window.ooooby = window.ooooby || {}, jQuery));

(function ($) {
    $.fn.turnOffValidation = function (form) {
        var settings = form.validate().settings;

        for (var ruleIndex in settings.rules) {
            delete settings.rules[ruleIndex];
        }
    };
})(jQuery);

$(document).ready(function () {
    ooooby.init();
});